import { useContext } from 'react';
import {
  CursorData,
  HandleData,
  KeyboardData,
  MouseData,
} from '../../types/hooks';
import { createStore } from '../dataStore/createStore';
import { EditorCtx } from './EditorContext';

export { EditorProvider } from './EditorContext';
export const useEditor = () => useContext(EditorCtx)!;

export const [MouseProvider, useMouse] = createStore<MouseData>();
export const [KeyboardProvider, useKeyboard] = createStore<KeyboardData>();
export const [HandleProvider, useHandle] = createStore<HandleData>();
export const [CursorProvider, useCursor] = createStore<CursorData>();
